<!-- eslint-disable no-console -->
<template>
    <div>        
        <gat-grid class="mt-3 gat-grid" :items="mappedData" :columns="gridColumns" :title=" mappingName +': '+ selectedAmount +'Kr'">
            <template slot="cell" slot-scope="slotprops" v-if="slotprops.column.header == 'Import'">
                <gat-edit v-if="!transExists(slotprops.row.fieldId)" class="gridCheckbox" v-model="slotprops.row.doImport" :checkbox="true" />                
                <span v-else></span>
            </template>
        </gat-grid>         
    
         <json-viewer v-if="false" :value="mappedData" :expand-depth="5" copyable  />
     </div>
 </template>
 
 <script >
 import Vue from "vue";
 import numeral from 'numeral';
  import JsonViewer from 'vue-json-viewer'
 import GatGrid from "../../../GatComponents/GatGrid.vue";
 import GatEdit from "../../../GatComponents/GatEdit.vue";
    
 
 
 export default Vue.extend({
    name: "MappedDataView",
    components: { GatGrid,
        JsonViewer,
          GatEdit},
    props: {mappedData: Array, mappingName: String, compactMode: Boolean, existingTransactions: Array},
    data() {
       return {
        
       };
    },
 
    activated() {},
 
    mounted() {
     
    },

    watch: {
        mappedData: function(val){
           if(val && val.length > 0){
            //wait for next tick
            this.$nextTick(() => {                
               this.selectAll();
                });
            }
        }
    },
 
    deactivated() {},
 
    computed: {
        gridColumns() {
         const columns = [
            { header: "Import", field: "doImport" },
            { header: "Date", field: "date" },
            { header: "Amount", field: "amount", dataType:"number", format:"#,0.00" },
            { header: "Text", field: "text" },          
            { header: "Account", field: "bankAccount"},
            { header: "FieldId", field: "fieldId" },
            { header: "Ref", field: "ref" },
         ];
         return columns;
      },

      selectedAmount(){
        const total = this.mappedData.filter(x => x.doImport).reduce((acc, x) => acc + x.amount, 0);        

        return numeral(total).format("#,0.00");
      },

      structuredData(){
        return this.parsedData.data;      
      }

    },
 
    methods: {
        selectAll(){
            this.mappedData.forEach(x => {
                if (!this.transExists(x.fieldId)) {
                    x.doImport = true;
                }
            });
        },

        transExists(bank_id){            
            if (this.existingTransactions == null) return false;
            
            return this.existingTransactions.some(x => x.TRA_BANK_ID == bank_id);
        }
       
      },
 });

 </script>
 
 <style scoped>
   .gridCheckbox {
      margin-top: 12px;
      margin-bottom: -12px;
   }



 </style>
 